export default __webpack_public_path__ + "static/media/logo-tailwind.2c38507a.png";